import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import ModalArticleInfo from '../../../molecules/ModalArticleInfo/ModalArticleInfoBrandAware';
import { SidebarQualitativeCTA } from './EditorialIntelligencePanel';

const ArticleModalSidebar = ({ article, isMobile, onOpenKpia, onRecalculate, readOnly }) => {
  if (isMobile) return null;

  return (
  <Grid item xs={12} md={3.48}>
    <Box sx={{
      position: { md: 'sticky' },
      top: { md: 16 },
      maxHeight: { md: 'calc(100vh - 220px)' },
      overflowY: { md: 'auto' },
      pb: 0,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' }
    }}>
      <Box sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        pb: 0,
        pt: 1.5
      }} />

      <Box sx={{ p: 2, pt: 0.5, pb: 10 }}>
        <Box sx={{ mb: 1 }}>
          <SidebarQualitativeCTA
            article={article}
            onClick={onOpenKpia}
            onRecalculate={readOnly ? undefined : onRecalculate}
          />
        </Box>

        <ModalArticleInfo
          article={article}
          hideQualitativeButton
          sx={{ my: 0, p: 0, border: 0, bgcolor: 'transparent' }}
        />
      </Box>
    </Box>
  </Grid>
  );
};

ArticleModalSidebar.propTypes = {
  article: PropTypes.shape({
    _id: PropTypes.string
  }).isRequired,
  isMobile: PropTypes.bool.isRequired,
  onOpenKpia: PropTypes.func.isRequired,
  onRecalculate: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};

ArticleModalSidebar.defaultProps = {
  readOnly: false
};

export default ArticleModalSidebar;
